import React from 'react';
import { graphql } from 'gatsby';
import { slugify } from '../utils/functions';
import Layout, { SEO } from '../components/Layout';
import { HeaderDefault } from '../components/Header';
import ListPortfolio from '../components/Projects';
import { ListPortfolioTags } from '../components/Projects/Tags';

const Client = ({ location, data }) => {
  //const meta = data.allPrismicClient;
  const source = data.allPrismicClient.edges
    .map(({ node }) => {
      return node.data.content.length <= 0 ? node : null;
    })
    .filter(function(el) {
      return el != null;
    });

  const catagory = location.pathname.replace('/portfolio/', '');
  const title = `<h1 style="text-transform: capitalize;">${catagory
    .replace('-', ' ')
    .replace('and', '&')
    .replace('-', ' ')}</h1>`;

  return (
    <Layout>
      <SEO
        title={catagory}
        desc={null}
        banner={null}
        pathname={`portfolio/${slugify(catagory)}`}
        firstDate={null}
        lastDate={null}
      />
      <HeaderDefault title={title} />
      <ListPortfolioTags />
      <ListPortfolio projects={source} />
    </Layout>
  );
};

export const query = graphql`
  query PortfolioTagQuery($tag: String!) {
    allPrismicClient(filter: { tags: { eq: $tag } }) {
      distinct(field: tags)
      edges {
        node {
          ...prismicClientProject
        }
      }
    }
  }
`;
export default Client;
